import React, { useEffect, useState } from "react";
import {
  Grid, Card, Button, TextField, Table, TableBody, TableCell,
  TableContainer, TableRow, Paper, MenuItem, Select
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import OrderStatusBadge from "./OrderStatusBadge";
import { Autocomplete } from "@mui/material";
import {
  Box, Typography, FormControl,
  InputLabel,

} from "@mui/material";

const OrderList = ({
  orders,
  orderStatuses,
  currentPage,
  totalPages,
  selectedStatus,
  searchValue,
  subCategories,
  categoryId,
  isMobile,
  handlePageChange,
  handleDetailClick,
  handleStatus,
  setSearchValue,
  setCategoryId,
  selectedY,
  selectedM
}) => {
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
    // const [filteredOrders, setFilteredOrders] = useState([]);

  const years = Array.from({ length: 10 }, (_, i) => ({
    id: 2020 + i,
    name: (2020 + i).toString(),
  }));
  const months = [
    { id: 1, name: "January" },
    { id: 2, name: "February" },
    { id: 3, name: "March" },
    { id: 4, name: "April" },
    { id: 5, name: "May" },
    { id: 6, name: "June" },
    { id: 7, name: "July" },
    { id: 8, name: "August" },
    { id: 9, name: "September" },
    { id: 10, name: "October" },
    { id: 11, name: "November" },
    { id: 12, name: "December" },
  ];

  useEffect(()=>{
    // console.log("Child Comp:",selectedYear?.id, selectedMonth?.id);
selectedY(selectedYear?.id);
selectedM(selectedMonth?.id);
  },[selectedYear,selectedMonth])
// useEffect(() => {
//   if (!orders || orders.length === 0) return;


//   const filtered = orders.filter((order) => {
//     if (!order.createdAt) return false;

//     const createdAt = new Date(order.createdAt);
//     const orderYear = createdAt.getFullYear();
//     const orderMonth = createdAt.getMonth(); 
    

//     const matchYear = selectedYear?.id ? orderYear === selectedYear.id : true;
//     const matchMonth = selectedMonth?.id !== undefined ? orderMonth === selectedMonth.id : true;

//     return matchYear && matchMonth;
//   });

//   setFilteredOrders(filtered);
// }, [selectedYear, selectedMonth, orders]);

  // 🧾 Handle Detail Click

  return (
    <MDBox pt={6} pb={3}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
              <MDTypography variant="h6" color="white">Orders</MDTypography>
            </MDBox>
            <MDBox pt={1} px={1}>
              <MDBox pt={1} px={1} display="flex" justifyContent="flex-end" alignItems="center" gap={2}>
              
                  {/* Year Autocomplete */}
                  <Autocomplete
                    options={years}
                    getOptionLabel={(option) => option?.name || ""}
                    value={selectedYear}
                    onChange={(e, value) => {
                      setSelectedYear(value);
                      setSelectedMonth(null); // Reset month when year changes
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Year"
                        variant="outlined"
                        size="small"
                        sx={{ width: 150}}
                      />
                    )}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                  />

                  {/* Month Autocomplete (only show after year selected) */}
                  {selectedYear && (
                    <Autocomplete
                      options={months}
                      getOptionLabel={(option) => option?.name || ""}
                      value={selectedMonth}
                      onChange={(e, value) => setSelectedMonth(value)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Month"
                          variant="outlined"
                          size="small"
                          sx={{ width: 150 }}
                        />
                      )}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                    />
                  )}

                  {/* Selected Info */}
                  {/* {selectedYear && selectedMonth && (
                    <Typography sx={{ mt: 2 }}>
                      📅 Selected: <b>{selectedMonth.name} {selectedYear.name}</b>
                    </Typography>
                  )} */}
              
                <Autocomplete
                  options={subCategories}
                  getOptionLabel={(option) => option?.name_en || ""}
                  value={subCategories.find((c) => c.id === categoryId) || null}
                  onChange={(e, value) => setCategoryId(value?.id || null)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Filter by Category"
                      variant="outlined"
                      size="small"
                      sx={{ width: 200 }}
                    />
                  )}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                />
                <TextField
                  label="Search"
                  variant="outlined"
                  placeholder="Search by title or description"
                  style={{ width: "300px" }}
                  onChange={(e) => setSearchValue(e.target.value)}
                />
              </MDBox>

              <MDBox pt={1} px={1} display="flex" alignItems="center" gap={2} flexWrap="wrap">
                {isMobile ? (
                  <Select
                    value={selectedStatus}
                    onChange={(e) => handleStatus(e.target.value)}
                    variant="outlined"
                    fullWidth
                    size="small"
                  >
                    <MenuItem value="all">All</MenuItem>
                    {orderStatuses.map((status) => (
                      <MenuItem key={status.id} value={status.id}>{status.name}</MenuItem>
                    ))}
                  </Select>
                ) : (
                  <>
                    <Button
                      variant={selectedStatus === "all" ? "contained" : "outlined"}
                      color="primary"
                      style={{ color: selectedStatus === "all" ? "white" : "black" }}
                      onClick={() => handleStatus("all")}
                    >All</Button>
                    {orderStatuses.map((status) => (
                      <Button
                        key={status.id}
                        variant={selectedStatus === status.id ? "contained" : "outlined"}
                        color="primary"
                        style={{ color: selectedStatus === status.id ? "white" : "black" }}
                        onClick={() => handleStatus(status.id)}
                      >{status.name}</Button>
                    ))}
                  </>
                )}
              </MDBox>

              <TableContainer component={Paper} style={{ marginTop: "1px" }}>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell style={{ fontWeight: "bold" }}>Order Ref</TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>Customer</TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>Driver</TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>Category</TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>Service Type</TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>Current Status</TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>Actions</TableCell>
                    </TableRow>
                    {orders.map((order) => (
                      <TableRow key={order.id}>
                        <TableCell>{order.order_ref}</TableCell>
                        <TableCell>{order.user?.full_name}</TableCell>
                        <TableCell>{order.driver ? order.driver.full_name : "N/A"}</TableCell>
                        <TableCell>{order.category?.name_en}</TableCell>
                        <TableCell>{order.service_type?.name_en}</TableCell>
                        <TableCell><OrderStatusBadge status={order.current_order_status?.name} /></TableCell>
                        <TableCell>
                          <Button onClick={() => handleDetailClick(order)} color="primary" size="small">Detail</Button>
                        </TableCell>
                      </TableRow>
                    ))}
                       {/* {filteredOrders.length > 0 ? (
            filteredOrders.map((order) => (
              <TableRow key={order.id}>
                <TableCell>{order.order_ref}</TableCell>
                <TableCell>{order.user?.full_name}</TableCell>
                <TableCell>
                  {order.driver ? order.driver.full_name : "N/A"}
                </TableCell>
                <TableCell>{order.category?.name_en}</TableCell>
                <TableCell>{order.service_type?.name_en}</TableCell>
                <TableCell>
                  <OrderStatusBadge status={order.current_order_status?.name} />
                </TableCell>
                <TableCell>
                  <Button
                    onClick={() => handleDetailClick(order)}
                    color="primary"
                    size="small"
                  >
                    Detail
                  </Button>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={7} align="center">
                No orders found for the selected month/year.
              </TableCell>
            </TableRow>
          )} */}
                  </TableBody>
                </Table>
              </TableContainer>

              <MDBox mt={2} display="flex" justifyContent="center" alignItems="center">
                <Button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</Button>
                <MDTypography mx={2}>Page {currentPage} of {totalPages}</MDTypography>
                <Button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</Button>
              </MDBox>
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
};

export default OrderList;